import {
  ChevronDownIcon,
  ChevronsUpIcon,
  ChevronUpIcon,
  PauseIcon,
} from "lucide-react";

import { DropDownCell } from "@/components/DropDownCell";

import { useUpdateSetJobPriority } from "@/hooks/updateSets/useUpdateSetJobPriority";
import { ChipSelectOption, JobPriority } from "@/types";

const PRIORITY_OPTIONS: ChipSelectOption<JobPriority>[] = [
  {
    value: JobPriority.HIGH,
    label: "High",
    icon: ChevronsUpIcon,
    selectedClassName:
      "border-[#D14343] bg-[#D14343]/15 text-[#9B3030] hover:bg-[#D14343]/20 hover:text-[#9B3030]",
    iconClassName: "text-[#9B3030]",
  },
  {
    value: JobPriority.MEDIUM,
    label: "Medium",
    icon: ChevronUpIcon,
    selectedClassName:
      "border-[#E67E22] bg-[#E67E22]/15 text-[#c2410c] hover:bg-[#E67E22]/20 hover:text-[#c2410c]",
    iconClassName: "text-[#c2410c]",
  },
  {
    value: JobPriority.LOW,
    label: "Low",
    icon: ChevronDownIcon,
    selectedClassName:
      "border-[#2D9CDB] bg-[#2D9CDB]/15 text-[#1F6FA8] hover:bg-[#2D9CDB]/20 hover:text-[#1F6FA8]",
    iconClassName: "text-[#1F6FA8]",
  },
  {
    value: JobPriority.BACKBURNERED,
    label: "Backburnered",
    icon: PauseIcon,
    selectedClassName:
      "border-[#9B9B9B] bg-[#9B9B9B]/15 text-[#6B6B6B] hover:bg-[#9B9B9B]/20 hover:text-[#6B6B6B]",
    iconClassName: "text-[#6B6B6B]",
  },
];

export const PriorityCell = ({
  iconOnly = false,
  isSmall = false,
  job,
  readOnly = false,
}: {
  iconOnly?: boolean;
  isSmall?: boolean;
  job: {
    id?: string;
    priority: JobPriority | null;
  };
  readOnly?: boolean;
}) => {
  const { mutate: setJobPriority } = useUpdateSetJobPriority();

  return (
    <DropDownCell
      options={PRIORITY_OPTIONS}
      placeholder="Set priority"
      value={job.priority}
      clearable={false}
      iconOnly={iconOnly}
      isSmall={isSmall}
      readOnly={readOnly}
      pill={!iconOnly}
      onChange={(next) => {
        // Priority is always set. Ignore clears.
        if (!next || !job.id) return;
        setJobPriority({ jobId: job.id, priority: next });
      }}
    />
  );
};
